var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.shouldShowError
    ? _c(
        "div",
        { staticClass: "text-red-600 text-sm mb-2", class: _vm.customClass },
        [_vm._v(" " + _vm._s(_vm.errorMessage) + " ")]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }